import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Apollo } from 'apollo-angular';
import {MatPaginator} from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table'
import { MatSort } from '@angular/material/sort';;
import { DateAdapter } from "@angular/material/core";
import moment from 'moment';
import { NuevoUsuarioComponent } from 'src/app/components/portal-inproeco/usuarios/formularios/nuevo-usuario/nuevo-usuario.component';
import { MatDialog } from "@angular/material/dialog";

import { Workbook } from 'exceljs';
import * as fs from 'file-saver';

//SERVICIOS
import { UsuariosService } from 'src/app/services/usuarios.service';
import { ConfirmacionService } from 'src/app/services/confirmacion.service'
import { DetalleService} from 'src/app/services/detalle.service'
import { PaginatorService } from 'src/app/services/paginator.service';
import { DetalleUsuarioComponent } from '../detalle-usuario/detalle-usuario.component';


@Component({
  selector: 'app-tabla-usuarios-inproeco',
  templateUrl: './tabla-usuarios-inproeco.component.html',
  styleUrls: ['./tabla-usuarios-inproeco.component.scss']
})
export class TablaUsuariosInproecoComponent implements OnInit {


  public users: any[] = []
  public loading: Boolean
  public tableColumns: String[]
  public title: String
  public dataSource?: any
  public filterValue?: string

  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;

  constructor(private apollo: Apollo, private usuariosService: UsuariosService, private confirmacionService: ConfirmacionService, private detalleService: DetalleService,  date: DateAdapter<Date>, public dialog: MatDialog) { 
    this.loading = false;
    this.title = "Usuarios"
    this.tableColumns = ['id', 'name', 'username', 'email', 'jefe', 'acciones']
    date.getFirstDayOfWeek = () => 1
  }

  ngOnInit(): void {
    this.getAllUsuarios()
  }

   exportAsExcel() {
    
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet("Usuarios");
    let header = ["Id", "Nombre", "Usuario", "Mail"]
    let headerRow = worksheet.addRow(header);

    for (let user of this.users) {
      let temp = []
    
      // MAPEADO //
      temp.push(user["id"])
      temp.push(user["name"])
      temp.push(user["username"])
      temp.push(user["email"])
        
      worksheet.addRow(temp)
     
    }

    let fname = "Tabla Usuarios"

    workbook.xlsx.writeBuffer().then((data) => {

      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, fname + '-' + new Date().valueOf() + '.xlsx');
    });
  }

  getAllUsuarios(): void {
    this.apollo.watchQuery<any>({
      query: this.usuariosService.getAllUsuarios(),
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        console.log(data)
        this.loading = loading
        this.users = data.users
        this.setDataTableOptions()
      })
  }

  setDataTableOptions(){
    this.dataSource = new MatTableDataSource(this.users)
    this.dataSource.paginator = this.paginator;   
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (item: any, property: any) => {
      return this.sortingData(item, property)
    };
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      return this.filterPredicate(data, filter)
    }
  }

  applyFilter(e: any){
    this.filterValue = e.target.value
    this.dataSource.filter = this.filterValue?.trim().toLocaleLowerCase();
  }

  filterPredicate(data: any, filter: string){
    const dateFormatted = moment(data.createdAt).format('DD/MM/YYYY')
    return data.id.toLocaleLowerCase().includes(filter) ||
            data.email.toLocaleLowerCase().includes(filter) ||
            dateFormatted.includes(filter);
  }
  //TODO revisar sorting
  sortingData(item: any, property: any){
    switch(property) {
      case 'username': return item.username;
      default: return item[property];
    }
  }

  // addUsuario(): void {
  //   this.apollo.mutate({
  //     mutation: this.usuariosService.addUsuarios(),
  //     variables: {
  //       "input": {
  //         "data": {
  //           "nombre": "Nueva instalacion",
  //           "cliente": "600e9d1c0050670548851599",
            
  //         }
  //       }
  //     }
  //   }).subscribe(({data}) => {
  //     console.log('CREADO', data)
  //   }, (error) => {
  //     console.log('Error al lanzar la query', error);
  //   })
  // }




  // updateInstalacionById(id: String): void {
  //   this.apollo.mutate({
  //     mutation: this.instalacionService.updateInstalacion(),
  //     variables: {
  //       "input": {
  //         "where": {
  //           "id": id
  //         },
  //         "data": {
  //           "nombre": "Nueva instalacion Editada",
  //           "cliente": "6009afc3505e5c033c2ccbd3",
  //           /* "agrupacion": "6009b0edbd6439039ea2257c" */
  //         }
  //       }    
  //     }
  //   })
  //     .subscribe(({data, errors}) => {
  //       console.log("EDITADO", data, errors)
  //     }, (error) => {
  //       console.log('aaaaa',error)
  //     })
  // }



  deleteUsuarioById(id: String): void{
    this.apollo.mutate({
      mutation: this.usuariosService.deleteUser(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
        }
      }
    })
      .subscribe(({data}) => {
        console.log('BORRADO', data)
        location.reload()
      }, (error) => {
        console.log(error)
      })
  }

  handleClick(id: String){
    const options = {
      cancelText: 'Cancelar',
      confirmText: 'Eliminar'
    };
    this.confirmacionService.open(options);
      
    this.confirmacionService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.deleteUsuarioById(id)
      }
      });
  }

   openDialog() {
    this.dialog.open(NuevoUsuarioComponent);
  }

  openDetails(id: string){
    const options= {
      id: id,
      refreshTable: this.getAllUsuarios
    }
    this.detalleService.openTest(options, DetalleUsuarioComponent);
  }

  

}
